import configureEnvironment from '@/core/shared/setup/configureEnvironment';
configureEnvironment();
